import { HTTPClient } from "./Client";

const DadosAlunosAPI = {
    async EditarTabelaPessoa(dadosUsuario) {
    
        try {
            const response = await HTTPClient.put(`/Pessoa/AtualizarInformacoesPessoaPerfil`, dadosUsuario);
          
            return response.data;
        } catch (error) {
            console.error("Erro ao atualizar:", error);
            throw error;  
        }
    },
    

    async ObterInformacoesProcedure() {
        try {
            const response = await HTTPClient.get(`/Pessoa/InformacoesUsuario/`)
           
            return response.data;
        } catch (error) {
            console.error("Erro ao obter informações do usuário:", error);
        }
    },

    async AlterarSenhaPerfilUsuario(senhaAtual, senhaNova, confirmarSenha) {

        const dados = {
            senhaAtual: senhaAtual,
            novaSenha: senhaNova,
            confirmarNovaSenha: confirmarSenha
        };
        await HTTPClient.put(`/Usuario/AlterarSenhaUsuarioPerfil`, dados);
    }
}

export default DadosAlunosAPI;